import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "Communication Skills",
      
      nestedContent: [
        { id: 1, text: "•	Mastering clear and effective speech.", dummyText: [] },
        { id: 2, text: "•	Techniques for improving pronunciation, tone, and pacing.", dummyText: [] },
        { id: 3, text: "•	Public speaking strategies: engaging your audience and delivering impactful presentations.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Written Communication",
      nestedContent: [
        { id: 1, text: "•	Writing professional emails, reports, and documentation.", dummyText: [] },
        { id: 2, text: "•	Crafting clear and concise messages.", dummyText: [] },
        { id: 3, text: "•	Using proper grammar and tone for different contexts.", dummyText: [] },
        
       
      ],
    },
    {
        id: 3,
        title: " Active Listening",
        nestedContent: [
          { id: 1, text: "•	Understanding the importance of listening attentively.", dummyText: [] },
          { id: 2, text: "•	Techniques to improve focus and comprehension.", dummyText: [] },
          { id: 3, text: "•	Asking the right questions and clarifying understanding.", dummyText: [] },
         
        
        ],
      },
      
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title: " Self-Awareness",
      nestedContent: [
        { id: 1, text: "•	Understanding and recognizing your emotions.", dummyText: [] },
        { id: 2, text: "•	Identifying emotional triggers and reactions.", dummyText: [] },
        { id: 3, text: "•	Improving emotional regulation and mindfulness.", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: "  Empathy",
      nestedContent: [
        { id: 1, text: "•	The importance of empathy in building relationships.", dummyText: [] },
        { id: 2, text: "•	Techniques for understanding others’ perspectives and feelings.", dummyText: [] },
        { id: 3, text: "  •	How to express empathy effectively in conversations.", dummyText: [] },
       
      
      ],
    },
    {
        id: 3,
        title: " Emotional Regulation",
        nestedContent: [
          { id: 1, text: "•	Strategies for managing stress and difficult emotions.", dummyText: [] },
          { id: 2, text: "•	Maintaining calm under pressure and in conflict situations", dummyText: [] },
          { id: 3, text: "•	Using emotional intelligence to resolve misunderstandings and conflicts.", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: "Analytical Thinking",
      nestedContent: [
        { id: 1, text: "•	Approaching problems logically and systematically.", dummyText: [] },
        { id: 2, text: "•	Breaking down complex challenges into simpler steps.", dummyText: [] },
        { id: 3, text: "•	Developing reasoning skills to make better decisions.", dummyText: [] },
        
       
      ],
    },
    {
      id: 4,
      title: "Creative Problem-Solving",
      nestedContent: [
        { id: 1, text: "•	Encouraging creativity in your approach to challenges.", dummyText: [] },
        { id: 2, text: "•	Methods like brainstorming and lateral thinking.", dummyText: [] },
        { id: 3, text: "•	Overcoming mental blocks and finding innovative solutions.", dummyText: [] },
       
        
      ],
    },
    {
        id: 5,
        title: " 3 Decision Making",
        nestedContent: [
          { id: 1, text: "•	Understanding the decision-making process.", dummyText: [] },
          { id: 2, text: "•	Weighing pros and cons and managing risks.", dummyText: [] },
          { id: 3, text: "•	Strategies for making informed and confident decisions.", dummyText: [] },
          
        ],
      },
      
     
  ];
 
  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: "Building Team Relationships",
      nestedContent: [
        { id: 1, text: "•	The importance of building trust and respect in a team.", dummyText: [] },
        { id: 2, text: "•	Understanding different team roles and how to contribute effectively.", dummyText: [] },
        { id: 3, text: "•	Collaborating with diverse individuals and respecting differences.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "Conflict Resolution",
      nestedContent: [
        { id: 1, text: "•	Recognizing and addressing conflicts within a team.", dummyText: [] },
        { id: 2, text: "•	Using communication skills to mediate disagreements.", dummyText: [] },
        { id: 3, text: "•	Finding win-win solutions and promoting a healthy team dynamic.", dummyText: [] },
       
      ],
    },
    {
        id: 7,
        title: "Giving and Receiving Feedback",
        nestedContent: [
          { id: 1, text: "•	Providing constructive and actionable feedback.", dummyText: [] },
          { id: 2, text: "•	Receiving feedback with an open mind and using it for growth.", dummyText: [] },
          { id: 3, text: "•	Practicing positive feedback to encourage others.", dummyText: [] },
        
        ],
      },
      
      
      
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Managing Change",
      nestedContent: [
        { id: 1, text: "•	Understanding how to cope with change in the workplace.", dummyText: [] },
        { id: 2, text: "•	Developing resilience and embracing new challenges.", dummyText: [] },
        { id: 3, text: " •	Adapting your strategies when faced with new or unexpected situations.", dummyText: [] },

       
      ],
    },
    {
      id: 8,
      title: " Learning Agility",
      nestedContent: [
        { id: 1, text: "•	The importance of continuous learning and unlearning.", dummyText: [] },
        { id: 2, text: "•	Developing a growth mindset to thrive in fast-paced environments.", dummyText: [] },
        { id: 3, text: "•	Seeking feedback and adjusting your approach based on new insights.", dummyText: [] },
      ],
    },
    {
        id: 9,
        title: "Time Management",
        nestedContent: [
          { id: 1, text: "•	Effective time management strategies (e.g., Pomodoro, time-blocking).", dummyText: [] },
          { id: 2, text: "•	Prioritizing tasks based on urgency and importance", dummyText: [] },
          { id: 3, text: "•	Overcoming procrastination and improving productivity.", dummyText: [] },
        ],
      },
      
      
      
  ];

  const extraAdvancedModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "   Leadership Styles",
      nestedContent: [
        { id: 1, text: "•	Understanding different leadership styles (transformational, transactional, etc.).", dummyText: [] },
        { id: 2, text: "•	Identifying your own leadership style and strengths.", dummyText: [] },
        { id: 3, text: " •	Leading by example and inspiring others.", dummyText: [] },
      ],
     
    },
    {
      id: 10,
      title: "Motivation and Inspiration",
      nestedContent: [
        { id: 1, text: "•	Techniques for motivating yourself and others.", dummyText: [] },
        { id: 2, text: "•	Building confidence and morale in teams.", dummyText: [] },
        { id: 3, text: " •	Using positive reinforcement to encourage high performance.", dummyText: [] },
      ],
     

    },
    {
      id: 11,
      title: "Negotiation and Persuasion",
      nestedContent: [
        { id: 1, text: "•	Effective negotiation strategies in professional settings.", dummyText: [] },
        { id: 2, text: "•	Building rapport and influencing others without manipulation.", dummyText: [] },
        { id: 3, text: "•	Communicating with confidence to persuade and achieve desired outcomes.", dummyText: [] },
       
      ],
    },
    
  ];


  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-49px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        Comprehensive Soft Skills Development Curriculum
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
     Emotional Intelligence (EI)
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
       Problem-Solving and Critical Thinking
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
       Collaboration and Teamwork
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
  Adaptability and Flexibility
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
      Leadership and Influence
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      
    </div>
  );
};

export default LearningPathTFD;




